<!-- viewBox="0 0 16 16" -->
<template>
  <g clip-path="url(#clip0_4757_5484)">
    <path
      d="M11.9277 7.53223C12.3419 7.53223 12.6777 7.86801 12.6777 8.28223C12.6775 10.8044 10.854 12.8245 8.42969 13.1738V14.6963H10.168L10.2441 14.7002C10.6225 14.7385 10.918 15.0579 10.918 15.4463C10.9177 15.8345 10.6223 16.1541 10.2441 16.1924L10.168 16.1963H5.29688C4.88282 16.1963 4.54714 15.8603 4.54688 15.4463C4.54688 15.0321 4.88266 14.6963 5.29688 14.6963H6.92969V13.1738C4.50444 12.8253 2.67992 10.8051 2.67969 8.28223C2.67969 7.86801 3.01547 7.53223 3.42969 7.53223C3.8439 7.53223 4.17969 7.86801 4.17969 8.28223C4.17994 10.2087 5.69409 11.721 7.66602 11.7275H7.69141C9.66337 11.7211 11.1775 10.2087 11.1777 8.28223C11.1777 7.86807 11.5136 7.53231 11.9277 7.53223ZM7.67871 0.196289C9.12961 0.196289 10.2695 1.32207 10.2695 2.75488V8.07715C10.2694 9.50985 9.12953 10.6357 7.67871 10.6357C6.22794 10.6357 5.08804 9.50982 5.08789 8.07715V2.75488C5.08791 1.3221 6.22786 0.196339 7.67871 0.196289Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_4757_5484">
      <rect width="16" height="16" fill="currentColor" />
    </clipPath>
  </defs>
</template>
